import { Component } from '@angular/core';
import { PriceService, GungFlowService, AuthService, LocationConfigService, GungAnonymousConfigService } from 'gung-standard';
import { JeevesProductGridViewComponent } from 'gung-standard-jeeves';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'ref-ref-jeeves-product-grid-view',
    templateUrl: './ref-jeeves-product-grid-view.component.html',
    styleUrls: ['./ref-jeeves-product-grid-view.component.scss'],
    standalone: false
})
export class RefJeevesProductGridViewComponent extends JeevesProductGridViewComponent {
  isCapstone = environment.projectName === 'capstone';

  constructor(
    protected priceService: PriceService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected router: Router,
    protected locationConfigService: LocationConfigService,
    protected gungAnonymousConfigService: GungAnonymousConfigService,
  ) {
    super(priceService, gungFlowService, authService, gungAnonymousConfigService, router, locationConfigService);
  }
}
